import { useMutation } from 'react-query'
import { get } from 'framework/api/http'

interface GetBulkStatusUpdateLogTableInterface {
  take?: number
  skip?: number
}
export const useGetBulkStatusUpdateLogTable = () => {
  const mutate = useMutation(
    ({ take, skip }: GetBulkStatusUpdateLogTableInterface) => {
      return get(
        `/PartnerOrders/Manage/ListBulkStatusUploadHistory?take=${take}&skip=${skip}`,
      )
    },
  )
  return mutate
}
export default useGetBulkStatusUpdateLogTable
